module.exports = require("../shapes/BladeToolbarButtonPropShape");


//////////////////
// WEBPACK FOOTER
// external "../shapes/BladeToolbarButtonPropShape"
// module id = 4
// module chunks = 1